import React, { useEffect, useState } from "react";
import NumberFormat from "react-number-format";
import { useHistory, useParams } from "react-router-dom";
import { Button, Dimmer, Icon, Loader } from "semantic-ui-react";
import OrderModel from "../../admin/components/order/order.model";
import "../../admin/components/order/order.scss";
import { parseStatus } from "../../utils/shared.utils";
import "./order-receipt-print.scss";

function OrderReceiptPrintComponent() {
  const { token } = useParams<{ token: string }>();
  const history = useHistory();
  const [order, setOrder] = useState<OrderModel | null>(null);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [receiptCount, setReceiptCount] = useState(0);

  useEffect(() => {
    if (token) {
      fetchOrderDetails();
      window.scrollTo(0, 0);
    }
  }, [token]);

  const incrementReceiptCount = async () => {
    if (!order?.id) return;
    
    const clientToken = localStorage.getItem("clientToken");
    if (!clientToken) return;

    try {
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}mongol/order/increment-receipt/${order.id}`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            Authorization: clientToken,
            "Content-Type": "application/json",
          },
        }
      );
      if (res.ok) {
        const data = await res.json();
        setReceiptCount(data.receiptCount);
      }
    } catch (err) {
      console.error("Failed to increment receipt count:", err);
    }
  };

  const fetchOrderDetails = () => {
    const clientToken = localStorage.getItem("clientToken");
    if (clientToken && clientToken !== "undefined") {
      setLoading(true);
      fetch(`${process.env.REACT_APP_API_URL}client/order-detail/${token}`, {
        method: "GET",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: clientToken,
        },
      })
        .then((res: any) => {
          setLoading(false);
          if (res.ok) {
            res.json().then((resJson: any) => {
              let orderObj = resJson.order;
              for (let delivery of orderObj.deliveries) {
                let date = new Date(delivery.date);
                delivery.date = `${date.getMonth() + 1} сарын ${date.getUTCDate()}`;
              }
              setOrder(orderObj);
              setReceiptCount(orderObj.receiptCount || 0);
            });
          } else {
            setErrorMsg("Захиалга олдсонгүй");
          }
        })
        .catch((err) => {
          setLoading(false);
          setErrorMsg("Сүлжээний алдаа");
          console.error(err);
        });
    } else {
      history.push("/login");
    }
  };

  const handlePrint = () => {
    const style = document.createElement("style");
    style.id = "print-receipt-style";
    style.textContent = `
      @media print {
        /* Hide all layout elements */
        header,
        nav,
        footer,
        .main-layout,
        .client-layout > :first-child,
        .client-head,
        .print-button-container {
          display: none !important;
        }
        /* Show only receipt */
        .receipt-print-2 { 
          display: flex !important; 
        }
        .print-line-title,
        hr {
          display: none !important;
        }
        /* Full page receipt */
        .order-receipt-print-page {
          margin: 0;
          padding: 0;
        }
        body {
          margin: 0;
          padding: 0;
        }
      }
    `;
    document.head.appendChild(style);
    
    // Increment count when user actually prints
    const afterPrint = () => {
      incrementReceiptCount();
      window.removeEventListener("afterprint", afterPrint);
    };
    window.addEventListener("afterprint", afterPrint);
    
    window.print();
    setTimeout(() => {
      const styleEl = document.getElementById("print-receipt-style");
      if (styleEl) styleEl.remove();
    }, 1000);
  };

  if (loading) {
    return (
      <div className="order-receipt-print-page">
        <Dimmer active={true} inverted>
          <Loader size="medium"></Loader>
        </Dimmer>
      </div>
    );
  }

  if (errorMsg || !order) {
    return (
      <div className="order-receipt-print-page">
        <div className="error-msg">{errorMsg || "Захиалга олдсонгүй"}</div>
        <Button onClick={() => history.goBack()}>Буцах</Button>
      </div>
    );
  }

  return (
    <div className="order-receipt-print-page page-order">
      <div className="print-button-container">
       <Button onClick={() => history.goBack()}>
        <Icon name="arrow left" />
       </Button>
        <Button className="btn-primary" onClick={handlePrint}>
          <Icon name="print" />
          Хэвлэх (Хэвлэсэн: {receiptCount})
        </Button>
      </div>

      <hr />
      <div className="receipt-container receipt-print-2">
        {[1, 2].map((dummy: any, dummyi: number) => {
          return (
            <div className="receipt" key={"receipt-" + dummyi}>
              <h2>Баримт</h2>
              <div>
                <div className="client-order">
                  <div className="business-name">Шеф Про ХХК</div>
                  <div className="order-top">
                    <div className="order-col order-id fontMain-2">
                      <div className="col-top">№</div>
                      <div>
                        <strong>{order?.token}</strong>
                      </div>
                    </div>
                    <div className="order-col order-amount">
                      <div className="col-top">Нийт дүн</div>
                      <div>
                        <NumberFormat
                          displayType={"text"}
                          value={order?.totalAmount}
                          suffix="₮"
                          thousandSeparator={true}
                        />
                      </div>
                    </div>
                    <div className="order-col">
                      <div className="col-top">Төлөв</div>
                      <div
                        className={`order-status ${String(
                          order?.status || ""
                        ).toLowerCase()}`}
                      >
                        {parseStatus(order?.status || "")}
                      </div>
                    </div>
                  </div>

                  <div className="order-items">
                    {order.companyName ? (
                      <>
                        <div className="order-contact">
                          <strong>Байгууллагын нэр: </strong>
                          {order.companyName}
                        </div>
                        <div className="order-contact">
                          <strong>Байгууллагын регистр: </strong>
                          {order.companyRegister}
                        </div>
                        <div className="order-contact">
                          <strong>Утасны дугаар: </strong>
                          {order.companyPhone}
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="order-contact">
                          <strong>Нэр: </strong>
                          {order.company?.name || order.ownName}
                        </div>
                        <div className="order-contact">
                          <strong>Утас: </strong>
                          {order.company?.phone || order.phone}
                        </div>
                      </>
                    )}
                    <div className="order-address">
                      <strong className="col-top">Хаяг: </strong>
                      <span>
                        {order.town}, {order.district}, {order.unit},{" "}
                        {order.street}
                      </span>
                    </div>

                    {order.deliveries?.map((delivery: any, dindex: number) => {
                      return (
                        <div
                          className="order-delivery"
                          key={"delivery-" + delivery.id}
                        >
                          <div className="order-delivery-top">
                            <span className="delivery-date">
                              <Icon name="calendar outline" />
                              {delivery?.date} &nbsp;
                            </span>
                            <span className="delivery-cost">
                              {" "}
                              - Хүргэлтийн үнэ: -{" "}
                              <NumberFormat
                                displayType="text"
                                value={delivery?.cost}
                                thousandSeparator={true}
                                suffix="₮"
                              />
                            </span>
                          </div>
                          <table>
                            <tbody>
                              {delivery?.items?.map(
                                (item: any, index: number) => {
                                  return (
                                    <tr key={`order-${item.id}-${index}`}>
                                      <td>
                                        {item.product.name}{" "}
                                        {item.product.size
                                          ? " - " + item.product.size
                                          : ""}{" "}
                                        {item.product.size
                                          ? item.product.unit
                                          : ""}
                                      </td>
                                      <td>
                                        <NumberFormat
                                          displayType="text"
                                          value={item.price}
                                          suffix="₮"
                                          thousandSeparator={true}
                                        />{" "}
                                        x {item.count} &nbsp;=&nbsp;
                                        <NumberFormat
                                          displayType="text"
                                          value={item.price * item.count}
                                          suffix="₮"
                                          thousandSeparator={true}
                                        />
                                      </td>
                                    </tr>
                                  );
                                }
                              )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </div>
                  <div className="order-summary">
                    <div>
                      Барааны нийт үнэ:{" "}
                      <NumberFormat
                        displayType="text"
                        value={
                          (order.totalAmount || 0) -
                          (order.totalDeliveryCost || 0)
                        }
                        suffix="₮"
                        thousandSeparator={true}
                      />
                    </div>
                    <div>
                      Хүргэлтийн нийт үнэ:{" "}
                      <NumberFormat
                        displayType="text"
                        value={order.totalDeliveryCost || 0}
                        suffix="₮"
                        thousandSeparator={true}
                      />
                    </div>
                    <div>
                      Нийт үнэ:{" "}
                      <NumberFormat
                        displayType="text"
                        value={order.totalAmount || 0}
                        suffix="₮"
                        thousandSeparator={true}
                      />
                    </div>
                    <br />
                    {order.payLater ? (
                      <div>
                        Төлбөр төлөх дансны дугаар: MN570004000438016886
                        (Худалдаа Хөгжлийн Банк)
                      </div>
                    ) : null}
                    <hr />
                    <div className="two-col">
                      <div className="signs">
                        <div>Хүргэсэн: </div>
                        <br />
                        <div>Хүлээн авсан: </div>
                      </div>
                      <div className="stamp">
                        <img src="/chef-pro-seal.png" height="70" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default OrderReceiptPrintComponent;

